import { FilterResultModel, HttpModel, IFile, PaginationModel } from '@/Shared/domain'
import type { ProductModel, TransactionModel, TransactionsRepository } from '@/Transactions/domain'
import { TransactionFilterLocals } from '@/Transactions/domain/TransactionFilterLocals'

interface ITransactions {
  getFilterValues: () => Promise<HttpModel<ProductModel>>
  get: (
    page: number,
    numberOfRecordsPerPage: number,
    filters?: FilterResultModel[],
  ) => Promise<HttpModel<PaginationModel<TransactionModel>>>
  download: (filters?: FilterResultModel[], isNursery?: boolean) => Promise<HttpModel<IFile>>
  getLocalsFilter: () => Promise<HttpModel<TransactionFilterLocals[]>>
  getGuarderia: (
    page: number,
    numberOfRecordsPerPage: number,
    filters?: FilterResultModel[],
  ) => Promise<HttpModel<PaginationModel<TransactionModel>>>
}

export const TransactionsContract = (
  transactionsRepository: TransactionsRepository,
): ITransactions => ({
  getFilterValues: async (): Promise<HttpModel<ProductModel>> =>
    await transactionsRepository.GetFilterValues(),
  get: async (
    page: number,
    numberOfRecordsPerPage: number,
    filters?: FilterResultModel[],
  ): Promise<HttpModel<PaginationModel<TransactionModel>>> =>
    await transactionsRepository.GetTransactionData(
      page,
      numberOfRecordsPerPage,
      filters,
    ),
  getGuarderia: async (
    page: number,
    numberOfRecordsPerPage: number,
    filters?: FilterResultModel[],
  ): Promise<HttpModel<PaginationModel<TransactionModel>>> =>
    await transactionsRepository.GetTransactionGuarderia(
      page,
      numberOfRecordsPerPage,
      filters,
    ),
  download: async (filters?: FilterResultModel[], isNursery?: boolean): Promise<HttpModel<IFile>> =>
    await transactionsRepository.DownloadTransactionData(filters, isNursery),
  getLocalsFilter: async (): Promise<HttpModel<TransactionFilterLocals[]>> =>
    await transactionsRepository.GetTransactionLocalsFilter(),
})
